import React from 'react';
import classnames from 'classnames';
import {ReactSVG} from "react-svg";
import {getPublicImagePath} from "@nutastic/nutastic-react-app";

const Header = () => {
    const componentClass = 'header';
    const classes = classnames(componentClass, 'animated', 'delay-2s', 'fadeIn');

    return <header className={classes}>
        <ReactSVG src={getPublicImagePath('up-emblem.svg')} className={`${componentClass}__logo`} />
    </header>;
};

export default Header;
